import Hls from 'hls.js';

export const attachHlsToPlayer = (player: HTMLVideoElement, source: string): typeof Hls => {
  const hls: any = new Hls();
  hls.loadSource(source);
  hls.attachMedia(player);
  return hls;
};
